import { UpgradePromotion } from "common/elements";
import { UserDashboard } from "features/user";
import { ProjectPreview } from "features/preview";
import { Rating, Feedback } from "features/review";
import { AssistantDialog } from "features/assistant";
import { Contact, UniversalPanel } from "features/universal";
import { RestrictedFeatureDialog } from "features/subscription";
import { SmartAppBanner, PwaInstallBanner } from "features/install";
import { ParentAccountAuthDialog, ParentRegistrationPromptDialog } from "features/auth";
import { AppLoading } from "./AppLoading";

export const DialogPage = () => {
  return (
    <>
      <Rating />
      <Contact />
      <Feedback />
      <UserDashboard />
      <AppLoading />
      <AssistantDialog />
      <UniversalPanel />
      <ProjectPreview />
      <SmartAppBanner />
      <RestrictedFeatureDialog />
      <PwaInstallBanner />
      <UpgradePromotion />
      <ParentAccountAuthDialog />
      <ParentRegistrationPromptDialog />
    </>
  );
};
